import { render, staticRenderFns } from "./UpdateRoomDialog.vue?vue&type=template&id=af5e911c"
import script from "./UpdateRoomDialog.vue?vue&type=script&lang=js"
export * from "./UpdateRoomDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports